import React, { Component } from "react";

import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import moment from "moment";
import StockUpdateOrderProductsTable from "./StockUpdateOrderProductsTable";

class StockUpdateOrderInvoice extends Component {
  render() {
    const {
      t,
      selectedOrder,
      products,
      setProducts,
      config,
      setEditMode,
      editMode,
      isViewOnly,
    } = this.props;
    return (
      <div
        className="jumbotron bg-white p-0 mt-4"
        style={{ paddingTop: 20, minWidth: 320 }}
      >
        <h5>{t("Invoice")}</h5>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{
              display: "flex",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Tracking Code")}:
            </span>
            <span>{selectedOrder.tracking_id}</span>
          </div>
          {selectedOrder.status == "Cancelled" ? (
            <div style={{ display: "flex" }}>
              <span
                style={{
                  fontWeight: "bold",
                  minWidth: 150,
                }}
              >
                {t("Cancelled date")}:
              </span>

              <span>
                {selectedOrder.cancelled_date
                  ? `${moment(selectedOrder.cancelled_date).format(
                      "MMM Do YYYY - h:mm a"
                    )} - ${t("by")} ${selectedOrder.cancelled_by__username}`
                  : "-"}
              </span>
            </div>
          ) : (
            <>
              <div style={{ display: "flex" }}>
                <span
                  style={{
                    fontWeight: "bold",
                    minWidth: 150,
                  }}
                >
                  {t("Placed")}:
                </span>

                <span>
                  {selectedOrder.created
                    ? `${moment(selectedOrder.created).format(
                        "MMM Do YYYY - h:mm a"
                      )} - ${t("by")} ${selectedOrder.created_by__username}`
                    : "-"}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    minWidth: 150,
                  }}
                >
                  {t("Completed Date")}:
                </span>
                <span>
                  {selectedOrder.completed_date
                    ? `${moment(selectedOrder.completed_date).format(
                        "MMM Do YYYY - h:mm a"
                      )} - ${t("by")} ${selectedOrder.completed_by__username}`
                    : "-"}
                </span>
              </div>
            </>
          )}
          <div style={{ display: "flex" }}>
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Branch")}:
            </span>

            <span>
              {(config.language === "arabic" &&
                selectedOrder.branch__ar_name) ||
                selectedOrder.branch__name}
            </span>
          </div>
        </div>
        <StockUpdateOrderProductsTable
          products={products}
          setProducts={setProducts}
          selectedOrder={selectedOrder}
          setEditMode={setEditMode}
          editMode={editMode}
          isViewOnly={isViewOnly}
        />

        {selectedOrder.notes && (
          <>
            <h6>Note:</h6>
            <p>{selectedOrder.notes}</p>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
    settings: state.auth.settings,
    config: state.config,
    is_staff: state.auth.is_staff,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(StockUpdateOrderInvoice));
